// Read/write a small set of view params on the URL so users can share filtered map state.
// Schema:  /?c=biryani&lat=-37.81&lng=144.96&z=14&p=ChIJxxxx&open=1
//   c     = cuisine id (omitted if 'all')
//   lat   = current map center latitude
//   lng   = current map center longitude
//   z     = zoom (number)
//   p     = open details place_id (optional)
//   open  = '1' when the "Open now" filter is active (omitted otherwise)

function num(v) {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

export function readUrlState() {
  if (typeof window === "undefined") return {};
  const p = new URLSearchParams(window.location.search);
  return {
    cuisine: p.get("c") || null,
    lat: num(p.get("lat")),
    lng: num(p.get("lng")),
    zoom: num(p.get("z")),
    place_id: p.get("p") || null,
    openNow: p.get("open") === "1",
  };
}

export function writeUrlState({
  cuisine,
  lat,
  lng,
  zoom,
  place_id,
  openNow,
} = {}) {
  if (typeof window === "undefined") return;
  const p = new URLSearchParams();
  if (cuisine && cuisine !== "all") p.set("c", cuisine);
  if (lat != null) p.set("lat", Number(lat).toFixed(5));
  if (lng != null) p.set("lng", Number(lng).toFixed(5));
  if (zoom != null) p.set("z", String(Math.round(zoom * 10) / 10));
  if (place_id) p.set("p", place_id);
  if (openNow) p.set("open", "1");
  const qs = p.toString();
  const url = qs ? `?${qs}` : window.location.pathname;
  window.history.replaceState(null, "", url);
}
